import { ActionInterface } from './action.interface';
import { Observable } from 'rxjs/Observable';
import { CartInterface } from '../../../shared/models/cart/cart.interface';
import { PaymentService } from '../../../shared/services/payment.service';
import { Injectable } from '@angular/core';
import { ModeleEcheancierService } from '../../../shared/services/modeleEcheancier.service';

@Injectable()
export class OrderAction implements ActionInterface {
  public constructor(
    private paymentService: PaymentService,
    private modeleEcheancierService: ModeleEcheancierService
  ) {
  }

  /**
   * @param {CartInterface} cart
   * @returns {Observable<Array<any>>}
   */
  getAvailablePayment(cart: CartInterface): Observable<Array<any>> {
    return this.paymentService.getPayment(cart.id);
  }

  /**
   * @param {CartInterface} cart
   * @returns {Observable<Array<any>>}
   */
  getAvailableModeleEcheancier(cart: CartInterface): Observable<Array<any>> {
    return this.modeleEcheancierService.get(cart.id);
  }

}



// WEBPACK FOOTER //
// ./src/core/payment/actions/order.action.ts